import {format} from 'date-fns'

import {equipmentLabel, pickupLabel, plannedEndLabel} from './active-rentals-format'
import type {ActiveRental} from './schemas'

const UTF8_BOM = '﻿'

const CSV_HEADERS = [
    'Customer',
    'Order',
    'Order number',
    'Job',
    'Job name',
    'Rep',
    'Site',
    'Equipment out',
    'Units out',
    'On rent since',
    'Planned end date',
    'Past end date',
    'Pickup',
    'Pickup job',
    'Partial pickup',
] as const

function escapeCsvField(value: string) {
    return /[",\n\r]/.test(value) ? `"${value.replaceAll('"', '""')}"` : value
}

// Dates are written as raw YYYY-MM-DD API values.
export function buildActiveRentalsCsv(rows: ActiveRental[]): string {
    const lines = rows.map((row) =>
        [
            row.customerName,
            row.projectName,
            row.orderNumber ?? '',
            row.jobDisplayId ?? '',
            row.jobName ?? '',
            row.repName ?? '',
            row.sites.join('; '),
            row.equipment.map(equipmentLabel).join('; '),
            String(row.unitCount),
            row.onRentSince,
            row.plannedEndDate ?? plannedEndLabel(row),
            row.pastEndDate ? 'Yes' : '',
            pickupLabel(row),
            row.pickup?.displayId ?? '',
            row.partialPickup?.summary ?? '',
        ].map(escapeCsvField),
    )
    return `${UTF8_BOM}${[CSV_HEADERS.join(','), ...lines.map((line) => line.join(','))].join('\n')}`
}

export function downloadActiveRentalsCsv(rows: ActiveRental[], filename: string) {
    const blob = new Blob([buildActiveRentalsCsv(rows)], {type: 'text/csv;charset=utf-8'})
    const url = URL.createObjectURL(blob)
    const anchor = document.createElement('a')
    anchor.href = url
    anchor.download = filename
    anchor.click()
    URL.revokeObjectURL(url)
}

export function activeRentalsCsvFilename(scope: string, day: Date): string {
    const slug =
        scope
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-|-$/g, '') || 'all'
    return `active-rentals-${slug}-${format(day, 'yyyy-MM-dd')}.csv`
}
